var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _vm.showTemplate
        ? _c(
            "b-col",
            { attrs: { cols: "auto" } },
            [
              _c(
                "template-card",
                _vm._b(
                  {
                    attrs: {
                      thumbnail: _vm.campaignDetails.templateThumbnail,
                      "select-page": false,
                      "edit-template": "",
                      actions: _vm.editable,
                      "show-disabled-actions": !_vm.editable,
                    },
                    on: {
                      edit: _vm.handleTemplateEdit,
                      preview: _vm.handleTemplatePreview,
                      delete: _vm.handleTemplateDelete,
                    },
                  },
                  "template-card",
                  _vm.campaignDetails,
                  false
                )
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.create || _vm.editable
        ? _c(
            "b-col",
            {
              staticClass: "d-flex flex-column align-items-center",
              attrs: { cols: "auto" },
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "btn-transparent",
                  attrs: { to: _vm.goSelectTemplate },
                },
                [
                  _c("h5", { staticClass: "text-light-gray my-3" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.showTemplate
                            ? _vm.$t("global.words.select")
                            : _vm.$tc("global.words.click", 1)
                        ) +
                        "\n        "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "clickable text-primary",
                        attrs: { id: "select-template" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.showTemplate
                                ? _vm.$t("global.words.other")
                                : _vm.$t("global.words.here")
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.showTemplate
                            ? ""
                            : _vm.$t("campaigns.messages.toBeginDesigningEmail")
                        ) +
                        "\n      "
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("html-template-editor", {
        ref: "templateEditorContainer",
        attrs: {
          "template-id": _vm.campaignDetails.templateId,
          "template-name": _vm.campaignDetails.templateName,
          "template-source-url": _vm.templateSourceUrl,
          "preview-template": _vm.previewTemplate,
          "allow-save-as": false,
        },
        on: { save: _vm.onSaveHandler, hidden: _vm.handleEditorHidden },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }